import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, TrendingUp, Users, Shield, Zap } from 'lucide-react';
import branding from '@/config/branding';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      {/* Header */}
      <header className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex flex-col">
            <h1 className="font-heading text-xl font-bold text-brand">{branding.platformName}</h1>
            <span className="text-[10px] text-gray-500 tracking-wide">Powered by InMeSta Ecosystem</span>
          </div>
          <Button
            variant="ghost"
            onClick={() => navigate('/login')}
            className="!bg-transparent text-[#64748B] hover:text-[#0F172A] hover:!bg-transparent"
          >
            Login
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 py-12 sm:py-20">
        <div className="text-center mb-12">
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0F172A] mb-6">
            INVEST IN THE FUTURE
          </h2>
          <p className="text-lg sm:text-xl text-[#64748B] max-w-2xl mx-auto mb-8">
            Access exclusive deal opportunities from India's most promising startups.
            Join our network of angels.
          </p>
          <Button
            data-testid="join-network-btn"
            onClick={() => navigate('/signup')}
            className="bg-brand hover:bg-brand-hover text-white h-14 px-8 text-lg font-semibold"
          >
            Join the Network
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-16">
          <Card className="border-[#E2E8F0] shadow-none">
            <CardContent className="p-6">
              <div className="w-12 h-12 bg-[#F1F5F9] rounded-md flex items-center justify-center mb-4">
                <TrendingUp className="h-6 w-6 text-brand" />
              </div>
              <h3 className="font-heading text-lg font-bold text-[#0F172A] mb-2">CURATED DEALS</h3>
              <p className="text-sm text-[#64748B]">Hand-picked investment opportunities from verified startups</p>
            </CardContent>
          </Card>

          <Card className="border-[#E2E8F0] shadow-none">
            <CardContent className="p-6">
              <div className="w-12 h-12 bg-[#F1F5F9] rounded-md flex items-center justify-center mb-4">
                <Users className="h-6 w-6 text-brand" />
              </div>
              <h3 className="font-heading text-lg font-bold text-[#0F172A] mb-2">NETWORK ACCESS</h3>
              <p className="text-sm text-[#64748B]">Connect with fellow angels and share insights</p>
            </CardContent>
          </Card>

          <Card className="border-[#E2E8F0] shadow-none">
            <CardContent className="p-6">
              <div className="w-12 h-12 bg-[#F1F5F9] rounded-md flex items-center justify-center mb-4">
                <Shield className="h-6 w-6 text-brand" />
              </div>
              <h3 className="font-heading text-lg font-bold text-[#0F172A] mb-2">SECURE PLATFORM</h3>
              <p className="text-sm text-[#64748B]">Premium verification and due diligence on every deal</p>
            </CardContent>
          </Card>

          <Card className="border-[#E2E8F0] shadow-none">
            <CardContent className="p-6">
              <div className="w-12 h-12 bg-[#F1F5F9] rounded-md flex items-center justify-center mb-4">
                <Zap className="h-6 w-6 text-brand" />
              </div>
              <h3 className="font-heading text-lg font-bold text-[#0F172A] mb-2">QUICK PROCESS</h3>
              <p className="text-sm text-[#64748B]">Fast onboarding and seamless deal participation</p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-[#E2E8F0] mt-20">
        <div className="max-w-7xl mx-auto px-4 py-8 text-center text-sm text-[#64748B]">
          © 2025 {branding.platformName}. Powered by InMeSta Ecosystem. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
